<template>
  <div id="families">
    <v-container class="pa-0">
      <v-layout>
        <router-link to="/admin/agencies/add" title="Add agency">
          <v-flex class="xs12 sm12 mb-5">
            <v-btn fab absolute right class="mr-3 pf-btn-fab">
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </router-link>
      </v-layout>
    </v-container>
    <v-layout>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
      v-model="search"
      append-icon="search"
      label="Search by Name"
      ></v-text-field>      
    </v-layout>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="AgencyList"
        :search="search" 
        :pagination.sync="pagination"
        class="pf-data-table"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }} </td>
          <td>{{ props.item.nickname }} </td>
          <td>{{ props.item.email[0].email }}</td>
          <td>{{ formatDate(props.item.createdAt) }}</td>
          <td align="right">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon small class="mr-0 ml-0" v-on="on">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                  </template>
                    <span>More</span>
                  </v-tooltip>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile @click="messageAdd(props.item)">
                  <v-list-tile-action>
                    <v-btn icon small class="mr-0 ml-0">
                      <v-icon size="22" color="grey darken-2">message</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-content>
                  <v-list-tile-title >
                    Message
                  </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="logonAgency(props.item)">
                  <v-list-tile-action>
                    <v-btn icon small class="mr-0 ml-0">
                      <v-icon size="22" color="grey darken-2">call_made</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-content>
                  <v-list-tile-title >
                    Dashboard
                  </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="resetPassword(props.item)">
                  <v-list-tile-action>
                    <v-btn icon small class="mr-0 ml-0">
                      <v-icon size="22" color="grey darken-2">lock</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                  <v-list-tile-content>
                  <v-list-tile-title >
                    Reset Password
                  </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
/* global session config store moment */
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import { getOne, getCollection, update, formatDate } from '../../helpers/helpers';

// This lists all the agencies available
export default {
  name: 'AgencyList',
  data: () => ({
    entity: 'Agency',
    search: '',
    pagination: {
      sortBy: 'name', // The field that you're sorting by
      rowsPerPage: config.dom.rowsPerPage
    },
    headers: [
      { text: 'Agency', value: 'name', align: 'left' },
      { text: 'Username', value: 'nickname', align: 'left' },
      { text: 'Email', value: 'email[0].email' },
      { text: 'Join Date', value: 'createdAt' },
      { text: '', sortable: false },
    ],
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  created () {
    this.initialize(this.$route.query && this.$route.query.requestFrom && this.$route.query.requestFrom === 'save');
  },
  mounted: function () {
    this.search = this.$route.params.profileStatus;
  },
  methods: {
    // @vuese
    // Used to initialize the agency list if not exists.
    async initialize (forceFetch = false) {
      if (!this.AgencyList.length || forceFetch) {
        let where = { _id: { $ne: this.Agency.id }, is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection(this.entity, true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    // @vuese
    // Used to format the mongo data string.
    // @arg The mongo date string
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    },
    // @vuese
    // Used to let admin message to a particular agency
    // @arg The agency object to which admin wants to message
    messageAdd (item) {
      let agencyItem = {
        id: item.id,
        avatar: item.avatar ? item.avatar : '',
        human: item.human[0].id,
        name: item.name,
        role: 'agency',
        _id: item.id
      };
      this.$router.push({ name: 'adminAddMessage', params: { item: agencyItem, preUrl: '/admin/agencies' }});
    },
    // @vuese
    // Used to login to any agency's dashboard.
    // @arg the agency object to which admin logins.
    async logonAgency (agency) {
      let sessionData;
      let { error, data } = await getOne('User', agency.human[0].user);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        delete data.access;
        sessionData = { ...session.getSession() };
        sessionData.adminUser = session.getSession().user;
        sessionData.user = data;
        session.setSession(sessionData, false);
        // window.location = config.client;
        location.reload();
      }
    },
    resetPassword (item) {
      let familyItem = {
        name: item.nickname,
        mapping_id: item.mapping_id,
        id: item.id,
        email: '',
        username: item.nickname,
        user_id: item.human[0].user
      };
      this.$router.push({ name: 'ResetPassword', params: { item: familyItem, preUrl: '/admin/agencies' }});
    }
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Agencies/list.vue